import httpClient from '@/lib/httpClient.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useCreateModel() {
  const queryClient = useQueryClient()

  const action = async ({ name = null, description }) => {
    return await httpClient.post('team/models', {
      name,
      description,
    })
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (e) => {
      toast.error(e?.response?.data?.message ?? 'An error occurred.')
    },
    onSuccess: (e) => {
      queryClient.invalidateQueries({
        queryKey: ['models'],
      })
      toast.success(e?.response?.data?.message ?? 'Model successfully created')
    },
  })

  return {
    createModel: mutation.mutateAsync,
  }
}
